const Footer = () => {
  return (
    <footer className="bg-emerald-900 text-white py-2 mt-auto">
      <div className="container mx-auto text-center">
        <p className="text-sm opacity-80">&copy; 2025 The Nexus Dormitory Management System. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;